import { Cell, TextInput } from '@zeiss/beyond-online-react';
import { Box, Grid } from '@zeiss/lib-components';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { BaseProps } from './';
import { MAX_CHARS_FOR_NAME } from 'src/constants';

export const ApplicationListName = ({
  setState,
  state: { error, name },
}: BaseProps) => {
  const { t } = useTranslation(['common']);

  const onChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    setState((prev) => ({
      ...prev,
      error: '',
      name: event.target.value,
    }));
  };

  return (
    <Box>
      <Grid>
        <Cell.Basic colSpan={[4, 6, 5]}>
          <TextInput
            autoComplete="off"
            error={error ? error : undefined}
            label={t('common:label.xName', {
              x: t('common:glossary.applicationList'),
            })}
            maxLength={MAX_CHARS_FOR_NAME}
            onChange={onChange}
            value={name}
          />
        </Cell.Basic>
      </Grid>
    </Box>
  );
};
